import "../../../scss/componentes/barraNavegacion/logo/logo.scss";
const ComponenteLogo = () => {
  return (
    <div className="logo">
      <div>
        <div>Desarrolladora Web Full Stack</div>
        <div className="subtitulo">Especializada en Fronted y Diseño web</div>
      </div>
    </div>
  );
};

export default ComponenteLogo;